module.exports = __webpack_public_path__ + "img/o.42d7c0fe.png";